import { reportStarPostEntry } from "./report-star-post-entry.ts"

export function addReportStarPostClickEvents() {
    if (!SiteInfo.isCCReportStarPostApiActive) {
        return
    }

    const reportButtons = document.querySelectorAll('[data-target="#report-post-modal"]')
    for (const element of reportButtons) {
        const htmlElement = element as HTMLElement
        if (htmlElement.dataset.clickBound) continue

        htmlElement.addEventListener("click", () => {
            reportStarPostEntry()
        })

        htmlElement.dataset.clickBound = "true"
    }
}
